export const competencies = {
  "A1.1": {
    id: "A1.1",
    header: "Rättsliga och administrativa krav",
    text: "Vägledaren bedriver vägledningsarbete i enlighet med lagstiftningen och de administrativa anvisningarna inom sitt område.",
    tunnistaa_ja_ymmartaa: [
      "viktigaste lagstiftningen om vägledning och dess operativa sammanhang",
      "lagstiftning om jämställdhet och likabehandling",
      "innehåll, administrativa anvisningar och grundläggande begrepp i aktuell lagstiftning inom sitt område",
      "interna anvisningar för sin egen organisation",
      "internationella avtal som Finland har förbundit sig till och som gäller ordnandet av vägledning",
    ],
    osaa: [
      "utföra vägledningsarbete och tillhandahålla vägledningstjänster i enlighet med aktuell lagstiftning och administrativa anvisningar inom den egna branschen",
      "agera i enlighet med de etiska principerna inom sin bransch",
      "dokumentera kundprocesser på ett ändamålsenligt sätt och samtidigt säkerställa skyddet av kunddata",
    ],
  },
  "A1.2": {
    id: "A1.2",
    header: "Yrkesansvar",
    text: "Vägledaren är medveten om gränserna för sitt yrke och sin kompetens och agerar därefter.",
    tunnistaa_ja_ymmartaa: [
      "gränserna för sitt yrke, sin professionalism och sin kompetens",
      "möjliga situationer och faktorer där gränserna för det egna yrket och den egna kompetensen kan överskridas",
      "betydelsen av den egna arbetsförmågan och välbefinnandet",
    ],
    osaa: [
      "agera i enlighet med etiska principer i sitt arbete",
      "upprätthålla en professionell interaktionsrelation mellan vägledare och kund",
      "beskriva sin egen kompetens och dess begränsningar för kunden",
      "agera inom ramen för sitt yrke och sin kompetens",
      "samråda med företrädare för andra yrkesgrupper när kundens situation kräver det",
      "vid behov hänvisa kunden till en annan yrkesgrupps tjänster",
      "dokumentera de åtgärder och beslut som överenskommits med kunden",
      "tydligt ange i kommunikationen när man agerar som yrkesutövare och när man agerar som privatperson",
      "ta hand om sitt eget välbefinnande och sin arbetsförmåga",
    ],
  },
  "A1.3": {
    id: "A1.3",
    header: "Etiska principer",
    text: "Vägledaren agerar i enlighet med de etiska principerna inom sitt område.",
    tunnistaa_ja_ymmartaa: [
      "etiska och filosofiska utgångspunkter för vägledning",
      "vägledningens etiska väsen",
      "arbetets innehåll, servicekanaler och situationer där etiska frågor kan uppstå",
      "sina egna värderingar, människosyn och etik",
      "centrala, internationella och nationella etiska principer inom sitt område",
      "teoriernas, tillvägagångssättens och arbetsformernas anknytningar till tid och kontext samt hur väl de kan tillämpas i respektive vägledningsprocess",
      "faktorer som påverkar etiska överväganden ur olika parters perspektiv",
      "jäv som uppstår i arbetet och verksamhetsmiljön",
    ],
    osaa: [
      "agera professionellt i enlighet med internationella och nationella etiska principer inom branschen",
      "kritiskt utvärdera sin verksamhet som vägledare och är medveten om hur egna värderingar, människosyn och etiskt tänkande påverkar vägledningsarbetet",
      "bedöma hur tillämpbara de teorier, tillvägagångssätt och arbetsmetoder som används i respektive vägledningsprocess är",
      "agera på ett sådant sätt att kundens intressen står i centrum för verksamheten",
      "verka i sitt arbete för att främja likabehandling, jämlikhet och rättvis",
      "använda kollegiala diskussioner för att stödja etiska överväganden",
      "konsultera experter när lösningar som kräver etisk prövning är nödvändiga",
      "undersöka riskerna och fördelarna med olika alternativ",
      "självständigt fatta etiskt motiverade beslut i sitt arbete",
      "föra fram etiskt motiverade perspektiv i organisationens vägledningsarbete",
      "ta initiativ för att främja etisk reflektion och handling i sina egna professionella nätverk",
    ],
  },
  "A1.4": {
    id: "A1.4",
    header: "Vägledningsrelation",
    text: "Vägledaren agerar i vägledningsrelationen i enlighet med de etiska principerna inom området",
    tunnistaa_ja_ymmartaa: [
      "kundernas mångfald och olika utgångspunkter (till exempel behov, funktionsförmåga, talanger, kompetens, omständigheter, värderingar, kultur, könsidentitet, religion osv.)",
      "intressekonflikter som kan påverka vägledarens objektivitet under kundens vägledningsprocess",
      "lagstiftningen samt den egna organisationens anvisningar och verksamhetsmodeller gällande lagring och bevarande av kunduppgifter",
    ],
    osaa: [
      "säkerställa att kunden är medveten om sina juridiska rättigheter och skyldigheter",
      "agera i enlighet med yrkesetiska principer i situationer med intressekonflikter",
      "agera i situationer där kunden uttrycker misstankar om att vägledaren inte agerar i enlighet med etiska principer",
      "främja tillgänglighet och jämlikhet i sitt arbete",
      "förklara utgångspunkterna och principerna för datalagring för kunderna",
      "berätta för kunderna var deras data lagras, hur de skyddas och hur länge de lagras",
      "se till att kunden ger sitt samtycke till att lagra nödvändiga uppgifter",
      "se till att kunden vid behov ger sitt samtycke till att information delas mellan olika aktörer",
    ],
  },
  "A2.1": {
    id: "A2.1",
    header: "Teoretisk kunskap",
    text: "Vägledaren baserar sitt arbete på centrala teorier och forskningsdata inom området. Med hjälp av teoretisk kunskap kan vägledaren också uppfatta vilka målen med vägledningsarbetet är och hurdana tillvägagångssätt som kan användas för att uppnå dem.",
    tunnistaa_ja_ymmartaa: [
      "en mångvetenskaplig kunskapsbas inom vägledningsområdet som omfattar olika vetenskapsområden och synvinklar",
      "centrala teorier inom vägledningsområdet och deras olika tillvägagångssätt",
      "centrala teorier och förhållningssätt inom discipliner relaterade till vägledningsarbetet",
    ],
    osaa: [
      "beskriva vägledningsområdets mångvetenskapliga kunskapsbas",
      "redogöra för grunderna i de centrala teorierna inom vägledningsområdet och deras tillämpning i vägledningsarbetet",
      "redogöra för centrala teorier inom olika vetenskapsområden som är relaterade till vägledningsområdet och deras betydelse för vägledningsarbetet",
      "hålla sig ajour med den teoretiska forskningens utveckling inom området",
    ],
  },
  "A2.2": {
    id: "A2.2",
    header: "Tillämpning av teoretiska kunskaper",
    text: "Vägledaren tillämpar ett brett spektrum av teorier i vägledningsarbetet. Vägledaren väljer de teorier, arbetsformer och arbetsmetoder som är bäst lämpade för kundens situation.",
    tunnistaa_ja_ymmartaa: [
      "de centrala teorierna och tillvägagångssätten inom området samt utgångspunkter baserade på forskningsdata",
      "de teoretiska grunderna bakom de valda arbetsformerna, förhållningssätten och åtgärderna samt deras tillämpning i kundarbetet",
    ],
    osaa: [
      "integrera teoretiska förhållningssätt till vägledning som en naturlig del av vägledningsarbetet",
      "beskriva hur hen tillämpar teoretisk kunskap i sitt eget arbete",
      "redogöra för utgångspunkterna för de viktigaste grundteorierna inom området och utifrån dessa välja de lämpligaste arbetsmetoderna för kundens situation",
      "bilda en tillämpbar bruksteori baserad på sina teoretiska kunskaper som ligger till grund för vägledningsarbetet",
      "samla in tillräckligt med information om kundens och gruppernas situation för att kunna välja lämpliga arbetsformer",
      "välja de lämpligaste arbetsformerna baserat på teori",
      "utvärdera och vid behov uppdatera sina egna arbetsmetoder utifrån de senaste forskningsrönen",
    ],
  },
  "A2.3": {
    id: "A2.3",
    header: "Forskning inom vägledningsområdet",
    text: "Vägledaren följer forskning och annan litteratur inom vägledningsområdet samt, med tanke på sitt arbete, relevanta aktörers och vetenskapsområdens publikationer. Att följa forskningen inom området är nära kopplat till andra kompetenser och den kontinuerliga utvecklingen av den egna yrkeskompetensen.",
    tunnistaa_ja_ymmartaa: [
      "de mest relevanta och heltäckande informationskällorna för vägledningsområdet samt forskningsorganisationer och -samfund som producerar relevant information om vägledningsområdet",
    ],
    osaa: [
      "inhämta forskningsinformation som är väsentlig för vägledningsarbetet",
      "bedöma forsknings relevans i det egna arbetet",
      "tillämpa forskningsresultat i det praktiska vägledningsarbetet och i planeringen, genomförandet och utvärderingen av vägledningen",
      "främja produktion, planering och genomförande av forskningsmaterial som gäller det egna arbetet och dess verksamhetsförutsättningar",
      "tillämpa ett forskningsbaserat förhållningssätt och grundläggande metoder för att utveckla sitt eget arbete",
      "dela med sig forskningsresultat till kollegor och samarbetspartner",
    ],
  },
  "A3.1": {
    id: "A3.1",
    header: "Reflekterande yrkesutövning",
    text: "Vägledaren utvärderar och utvecklar vägledningsarbetet tillsammans med kunder, kollegor, olika aktörer och intressentgrupper inom vägledning.",
    tunnistaa_ja_ymmartaa: [
      "grundläggande principer och faktorer för kritisk reflektion",
      "grundläggande begrepp, värderingar och attityder samt tanke- och verksamhetsmodeller",
      "gränserna för sitt yrke och sin kompetens",
      "bakgrundsfaktorer och samhälleliga utgångspunkter i anslutning till ordnandet av vägledningen",
      "vägledningens övergripande systemiska karaktär",
    ],
    osaa: [
      "utvärdera de etiska, teoretiska och filosofiska utgångspunkterna för den egna verksamheten och deras inverkan på vägledningsarbetet",
      "kritiskt granska sin egen verksamhet i olika vägledningsrelationer och processer i enlighet med områdets etiska principer och utgångspunkter",
      "bedöma utvecklingen av den egna kompetensen och yrkesidentiteten samt identifiera sina egna styrkor och utvecklingsområden",
      "identifiera och utvärdera effekten av den egna verksamheten ur individens, vägledningsprocessens, den egna organisationens och samhällets perspektiv",
      "kritiskt utvärdera och förnya sitt eget vägledningsarbete i samarbete med kunder, olika samarbetspartner och intressentgrupper",
      "beskriva vägledningens ställning som en del av den egna organisationens och förvaltningsområdets grundläggande uppgift",
    ],
  },
  "A3.2": {
    id: "A3.2",
    header: "Utveckling av personlig kompetens",
    text: "Vägledaren förbinder sig att identifiera personliga utvecklingsmål och kontinuerlig professionell utveckling.",
    tunnistaa_ja_ymmartaa: [
      "vikten av livslångt lärande och kontinuerlig kompetensutveckling i det egna arbetet",
      "mål, innehåll och områden som anknyter till eget arbete samt kompetenskrav",
      "teknologins nuvarande och framtida möjligheter i vägledningsarbetet",
      "utbildning som är relevant för den egna utvecklingen",
      "finansieringsmöjligheter för att kunna fokusera på att utveckla sin egen kompetens",
      "faktorer som påverkar arbetsförmågan och välbefinnandet",
    ],
    osaa: [
      "kritiskt bedöma sin egen och arbetsgemenskapens vägledningsverksamhet i förhållande till förändringar och megatrender i omvärlden",
      "bedöma konsekvenserna av lagstiftningen, verksamhetsmiljön och organisationens riktlinjer för verksamheten med tanke på det egna arbetet",
      "uppdatera sin egen arbetsbeskrivning och kompetens så att den motsvarar de förändringsbehov som uppstår",
      "bedöma möjligheterna till och användningen av dagens och framtidens teknologi i sitt vägledningsarbete",
      "utvärdera sin egen arbetsprestation och identifiera sina egna styrkor och utvecklingsområden",
      "upprätta och upprätthålla en personlig utvecklingsplan",
      "delta i fortbildning som stöder utvecklingen av den egna kompetensen",
      "utveckla sin egen verksamhet utifrån respons från kunder och samarbetspartner",
      "bedöma utvecklingen av den egna kompetensen och yrkesskickligheten",
      "dela med sig av sina erfarenheter i de egna yrkesnätverken och delta i professionella diskussioner inom vägledningsområdet",
      "bedöma och främja sin egen arbetsförmåga och sitt välbefinnande"
    ],
  },
  "A4.1": {
    id: "A4.1",
    header: "Tydlig kommunikation",
    text: "Vägledaren använder muntlig, skriftlig och visuell kommunikation på ett tydligt och begripligt sätt. Hen kommunicerar öppet och förståeligt på ett tillgängligt sätt i olika interaktionssituationer och kan ta hänsyn till kundernas olika förmågor att ta emot och förstå vägledarens kommunikation.",
    tunnistaa_ja_ymmartaa: [
      "betydelsen av tillgänglighet i kommunikation",
      "faktorer som främjar och begränsar effektiv kommunikation",
      "vikten av multilitteracitet i vägledningsarbete",
      "möjligheter och begränsningar med olika kommunikationskanaler",
      "den eventuella inverkan som vägledarens och kundernas olika bakgrundsfaktorer (till exempel språk, värderingar, kultur, livserfarenheter, studieförmåga) kan ha på kommunikationen",
      "viktiga utgångspunkter för kulturellt medveten kommunikation",
      "vikten av verbal och icke-verbal kommunikation",
      "ett lämpligt och tydligt skrivsätt och vikten av tydlig formatering av innehållet",
      "den visuella kommunikationens betydelse i vägledningsarbetet",
    ],
    osaa: [
      "använda ett lämpligt språk och lämpliga kommunikationskanaler med kunden och grupperna",
      "ta hänsyn till att kundernas förmåga och beredskap att kommunicera varierar beroende på ålder och bakgrund",
      "reglera tonen, hastigheten och intensiteten i språket",
      "säkerställa att icke-verbal kommunikation, såsom gester och ansiktsuttryck, stöder och kompletterar verbal kommunikation",
      "undvika otydligt språk, förkortningar eller yrkestermer i kommunikationen",
    ],
  },
  "A4.2": {
    id: "A4.2",
    header: "Målinriktad interaktion",
    text: "Vägledaren utnyttjar olika kanaler, metoder och verktyg i kommunikation och interaktion.",
    tunnistaa_ja_ymmartaa: [
      "skillnader mellan professionell interaktion och informell kommunikation",
      "möjligheter och begränsningar för professionell interaktion i vägledningen",
      "att vägledarens orientering till interaktions- och kommunikationssituationen lägger grunden för en målinriktad vägledningsprocess",
      "faktorer som främjar och begränsar aktivt mottagande av budskap",
      "den potentiella inverkan som vägledarens och kundens olika bakgrundsfaktorer (till exempel språk, språkregister, värderingar, kultur, livserfarenheter) kan ha på den ömsesidiga kommunikationen och tolkningen av budskapens betydelser",
      "vikten av verbal och icke-verbal kommunikation",
      "vikten av att använda olika typer av frågor i vägledningsprocessen",
    ],
    osaa: [
      "bygga upp en flerkanalig tillgänglig, funktionell och effektiv vägledningssituation, -process och -miljö enligt kundens behov",
      "agera i en interaktiv situation där målen för vägledningsprocessen står i centrum",
      "bygga upp en förtroendefull relation och upprätthålla den genom interaktion",
      "aktivt ta emot meddelanden från en annan person eller gruppmedlemmar",
      "förtydliga talat och skrivet språk vid behov",
      "bilda sig en uppfattning om kundens eller gruppmedlemmarnas kommunikation",
      "utvärdera vad kunden eller gruppen vill kommunicera",
      "undvika att göra tolkningar utifrån egna antaganden",
      "säkerställa att de egna verbala och icke-verbala meddelandena är konsekventa",
      "förmedla lyhördhet, intresse och uppmärksamhet i individuella väglednings- och gruppsituationer",
      "utveckla interaktion och gemensam kunskapsbildning",
      "främja bildandet av gemensam förståelse samt ömsesidigt förtroende och acceptans",
      "ta hänsyn till kundens och gruppens icke-verbala kommunikation och reagera på lämpligt sätt på den",
      "respektera andras personliga fysiska utrymme och upprätthålla den nödvändiga distansen i interaktionen",
    ],
  },
  "A4.3": {
    id: "A4.3",
    header: "Reflexiv kommunikation",
    text: "Vägledaren behärskar muntlig och skriftlig kommunikation, både i realtid och fördröjd, mellan professionella inom vägledning och handledning och kunden/grupperna. Samma principer gäller för alla professionella interaktionssituationer där vägledaren deltar.",
    tunnistaa_ja_ymmartaa: [
      "betydelsen av reflexiv kommunikation i processer där det är fråga om kundernas och gruppernas reflektion, förändring och utveckling",
      "olika frågeställningars inverkan på vägledningsprocessen, kundernas och gruppernas verksamhet samt erfarenheter av vägledningssituationer",
      "olika interventioners inverkan på vägledningsprocessen och måluppfyllelsen",
      "betydelsen av vägledarens egna och kundens tankar, handlingar, känslor och bakgrundsantaganden i vägledningen",
      "kulturens, uppväxtmiljöns och det omgivande samhällets inverkan på individens sätt att tänka och agera",
      "vikten av kritisk reflektion i interaktionssituationer",
    ],
    osaa: [
      "tolka den föränderliga omvärlden och uppfatta dess kulturella mångfald",
      "använda ändamålsenliga frågor och sätt att interagera med kunden eller gruppen",
      "bekräfta för kunden att hen har förstått kundens budskap och synpunkter",
      "sammanfatta dialogen",
      "vägleda kunden att granska sina tankar, känslor och beteenden samt att främja sin självkännedom",
      "utöver frågor använda vägledningstekniker som förtydligande, spegling, återkoppling, sammanfattning",
      "på lämpligt sätt använda konfrontation i situationer där det kan främja kundens eller gruppens reflektion och uppnående av mål",
      "fokusera på interaktionssituationen och beakta faktorer som kan främja eller störa kundens eller gruppens koncentration",
    ],
  },
  "A4.4": {
    id: "A4.4",
    header: "Professionell kommunikation",
    text: "Vägledaren kommunicerar som professionell i kundarbete och som representant för vägledningsbranschen i olika nätverk och arbetsgrupper. Hen kan också fungera som företrädare för yrkesområdet i undervisning, informationsmöten, publikationer, som medlem i arbetsgrupper samt i kollegialt och mångvetenskapligt samarbete.",
    tunnistaa_ja_ymmartaa: [
      "vikten av lämplig presentationsstil och utformning av innehåll beroende på målgrupp och sammanhang",
      "betydelsen av deltagarnas bakgrund och olika perspektiv med tanke på interaktionen",
      "betydelsen av samhällelig interaktion för vägledningens grundläggande uppgift",
    ],
    osaa: [
      "arbeta med olika människor och upprätthålla professionella relationer och nätverk",
      "agera som representant för sitt eget yrkesområde och sin organisation i kommunikationssituationer",
      "sammanfatta antingen vägledningsprocessen eller gemensamma diskussioner",
      "välja de viktigaste frågorna att föra fram",
      "definiera syftet med och innehållet i sitt budskap utifrån målgruppen",
      "presentera frågorna på ett övertygande sätt i olika offentliga sammanhang",
      "aktivt delta i det gemensamma arbetet i enlighet med överenskommelser med de berörda parterna",
      "främja och utveckla sin egen kommunikation så att arbetet i arbetsgemenskapens grupper och sektorsövergripande nätverk är målinriktat, funktionellt och effektivt",
    ],
    context_competencies: [
      {
        context: "Grundläggande utbildning",
        tunnistaa_ja_ymmartaa: [
          "betydelsen av interaktions- och kommunikationsfärdigheter som krävs för att arbeta sektorsövergripande, multiprofessionellt och i samarbete med vårdnadshavare och arbetsgivare",
          "att färdigheter och beredskap att interagera, kommunicera och ta emot information varierar hos elever i olika åldrar och med olika bakgrund",
        ],
        osaa: [
          "planera och genomföra lektioner, grupp- och interaktionssituationer samt kommunikation med beaktande av färdigheterna och kompetensen hos elever i olika åldrar och med olika bakgrund",
          "agera i sektorsövergripande och multiprofessionella sammanhang samt i kommunikation med vårdnadshavare och arbetsgivare",
          "tydligt beskriva innehållet i och tillgången till elevhandledning och elevvårdstjänster för elever och vårdnadshavar",
        ],
      },
      {
        context: "Utbildning på andra stadiet",
        tunnistaa_ja_ymmartaa: [
          "betydelsen av interaktions- och kommunikationsfärdigheter som krävs för att arbeta sektorsövergripande, multiprofessionellt och i samarbete med vårdnadshavare och arbetsgivare",
          "att färdigheter och beredskap att interagera, kommunicera och ta emot information varierar hos studerande i olika åldrar och med olika bakgrund",
          "principer och etiska frågor i samband med marknadsföringen av utbildning",
        ],
        osaa: [
          "planera och genomföra lektioner, grupp- och interaktionssituationer samt kommunikation med beaktande av färdigheterna och kompetensen hos studerande i olika åldrar och med olika bakgrund",
          "agera i sektorsövergripande och multiprofessionella situationer samt interaktionssituationer med vårdnadshavare och arbetsgivare",
          "tydligt beskriva innehållet i och tillgången till väglednings-, studiehandlednings- och stödtjänster för studerande, vårdnadshavare och samarbetspartner",
          "presentera läroanstaltens verksamhet och utbildningsutbud på ett mångsidigt och tydligt sätt",
          "ta hänsyn till att målgrupperna för marknadsföringen är olika beredda att ta emot budskapet",
        ],
      },
      {
        context: "Högre utbildning",
        tunnistaa_ja_ymmartaa: [
          "betydelsen av de interaktions- och kommunikationsfärdigheter som krävs för sektorsövergripande och mångprofessionellt samarbete i sitt arbete",
          "att färdigheter och beredskap att interagera, kommunicera och ta emot information varierar hos studenter i olika åldrar och med olika bakgrund",
          "principer och etiska frågor i samband med marknadsföringen av utbildning",
        ],
        osaa: [
          "planera och genomföra interaktionssituationer och kommunikation med beaktande av färdigheterna och kompetensen hos studenter i olika åldrar och med olika bakgrund",
          "agera i sektorsövergripande och multiprofessionella interaktionssituationer",
          "tydligt beskriva väglednings-, handlednings- och stödtjänsternas innehåll och tillgänglighet för studenter och samarbetspartner",
          "presentera högskolans verksamhet och utbildningsutbud på ett mångsidigt och tydligt sätt",
          "ta hänsyn till att målgrupperna för marknadsföringen är olika beredda att ta emot budskapet",
        ],
      },
      {
        context: "Arbets- och näringstjänster (AN-tjänster, TE-palvelut)",
        tunnistaa_ja_ymmartaa: [
          "betydelsen av de interaktions- och kommunikationsfärdigheter som behövs för sektorsövergripande och multiprofessionellt samarbete samt arbetslivssamarbete",
          "att färdigheter och beredskap att interagera, kommunicera och ta emot information varierar hos kunder i olika åldrar och med olika bakgrund",
        ],
        osaa: [
          "planera och genomföra interaktionssituationer och kommunikation med beaktande av färdigheterna och kompetensen hos kunder i olika åldrar och av olika typer",
          "agera i multidisciplinära och multiprofessionella interaktionssituationer",
          "beskriva innehållet i och tillgången till vägledning, och andra tjänster och stödformer för kunder och samarbetspartner",
        ],
      },
      {
        context: "Navigatorer",
        tunnistaa_ja_ymmartaa: [
          "betydelsen av de interaktions- och kommunikationsfärdigheter som behövs för sektorsövergripande och multiprofessionellt samarbete samt arbetslivssamarbete",
          "att färdigheter och beredskap att interagera, kommunicera och ta emot information varierar hos kunder i olika åldrar och med olika bakgrund",
        ],
        osaa: [
          "planera och genomföra interaktionssituationer och kommunikation med beaktande av färdigheterna och kompetensen hos kunder i olika åldrar och av olika typer",
          "agera i multidisciplinära och multiprofessionella interaktionssituationer",
          "tydligt beskriva innehållet i och tillgången till vägledning och andra tjänster och stödformer för kunder och samarbetspartner",
        ],
      },
    ],
  },
  "A5.1": {
    id: "A5.1",
    header: "Teknologi i vägledning",
    text: "Vägledaren utnyttjar teknologi på ett effektivt och ändamålsenligt sätt i samband med vägledning.",
    tunnistaa_ja_ymmartaa: [
      "den digitala teknologins roll i vägledningsarbetet och dess inverkan på vägledningsprocessen",
      "olika digitala verktyg och lösningar som är relevanta för vägledningsprocessen",
      "kundernas eventuella olika behov och förutsättningar för användning av digital teknologi i vägledningen",
      "vikten av tillgänglighet till digitala vägledningsmaterial",
      "den digitala teknologins möjligheter och begränsningar i vägledningsarbetet",
      "betydelsen av informationssäkerhet och integritetsskydd vid användning av digital teknologi i vägledningsarbetet",
      "den digitala teknologins roll som stöd för den egna professionella utvecklingen och dess inverkan på att utöka och uppdatera den egna kompetensen",
    ],
    osaa: [
      "välja de lämpligaste digitala verktygen och lösningarna för olika vägled- ningssituationer som lämpar sig bäst för kundens eller gruppens behov",
      "välja och använda tillgängliga digitala vägledningsmaterial",
      "använda digital teknologi för att lagra data och skydda kunddata, i enlighet med tillämpliga dataskyddsbestämmelser och praxis",
      "bedöma hur den digitala teknologin fungerar i vägledningsprocessen och vid behov göra ändringar i den teknologi som används för att förbättra vägledningsprocessens kvalitet",
      "använda digital teknologi för att utveckla sin yrkesskicklighet till exempel genom att delta i webbutbildningar, följa med webbinnehåll som anknyter till branschen och delta i professionella nätverk",
      "följa principerna för datasäkerhet och dataskydd vid användning av digital teknologi och säkerställa säker hantering och skydd av kunduppgifter",
      "kontinuerligt utveckla sin egen kompetens och hålla sig ajour med den teknologiska utvecklingen och dess inverkan på vägledningsarbetet samt anpassa sin egen verksamhet och sina egna metoder för att möta de möjligheter och utmaningar som teknologin medför",
    ],
  },
  "A5.2": {
    id: "A5.2",
    header: "Teknologi i vägledningsprocessen",
    text: "Vägledaren utnyttjar smidigt teknologi i vägledningsprocessen.",
    tunnistaa_ja_ymmartaa: [
      "hur olika digitala verktyg och applikationer kan stödja olika vägledningsfaser såsom datainsamling, måluppställning och uppföljning",
      "olika digitala interaktionskanalers särdrag och lämplighet, såsom videosamtal, chattar och e-post, i vägledningssituationer",
      "vikten av tillgänglighet till digitala vägledningsmaterial",
      "kundernas olika behov och önskemål vid användning av digital teknologi i vägledningen",
      "den digitala teknologins möjligheter och utmaningar under vägledningsprocessen",
      "hur digital teknologi kan integreras sömlöst i vägledningen så att den stöder vägledningsprocessen och kundens eller gruppens måluppfyllelse",
    ],
    osaa: [
      "välja och utnyttja lämpliga digitala verktyg och applikationer för vägledningsprocessens olika skeden, vägledningssituationer och kundgrupper",
      "välja och använda tillgängliga digitala vägledningsmaterial",
      "använda digital teknologi vid datainsamling och analys för att förstå kundens situation och planera vägledningsprocessen",
      "ge kunderna stöd och vägledning i att använda digital teknologi om den är ny eller utmanande för dem",
      "tillämpa goda interaktionsfärdigheter och praxis i den digitala miljön, såsom tydlig och begriplig kommunikation, aktivt lyssnande och empati",
      "bedöma den digitala teknologins effekt i vägledningsprocessen och vid behov ändra dess användning, innehåll och metoder",
      "skapa och upprätthålla en digital miljö som stöder vägledningsprocessen och kundens måluppfyllelse",
      "förhålla sig till digital teknologi som en del av vägledningsprocessens kontinuerliga utveckling och anpassa sig till teknologiska förändringar",
    ],
  },
  "A5.3": {
    id: "A5.3",
    header: "Gemensam användning av teknologi",
    text: "Vägledaren främjar gemensam användning av teknologi i vägledningsprocessen och professionellt samarbete samt möjliggör gruppvägledning och kamratstöd för kunder eller andra intressentgrupper. De använder den digitala teknologins möjligheter och verktyg för professionellt samarbete för att uppnå gemensamma mål.",
    tunnistaa_ja_ymmartaa: [
      "hur digital teknologi kan användas för att stödja gemensam vägledning och kollegialt lärande samt hur olika teknologier möjliggör gruppbaserad interaktion och informationsdelning",
      "hur man skapar en trygg och stödjande miljö för gruppbaserad användning av digital teknologi",
      "hur man tar hänsyn till deltagarnas olika kapacitet och behov när det gäller användningen av digital teknologi",
      "hur digital teknologi kan främja gruppdynamik och byggande av gemenskap under vägledningsprocessen",
      "den digitala teknologins potential för professionellt samarbete för att uppnå gemensamma mål",
    ],
    osaa: [
      "planera och genomföra gemensam vägledning med hjälp av digital teknologi och välja verktyg och metoder enligt gruppens behov",
      "instruera gruppen i användningen av digital teknologi och ge stöd till deltagarna vid behov",
      "skapa en trygg och öppen atmosfär som uppmuntrar deltagarna att dela med sig av sina erfarenheter och lära av varandra",
      "tillämpa goda interaktionsfärdigheter och god praxis i den digitala miljön, såsom tydlig och begriplig kommunikation, aktivt lyssnande och empati",
      "utnyttja olika faciliteringsmetoder för att främja interaktion i digitala miljöer",
      "ta hänsyn till olika inlärningsmetoder och erbjuda gruppen mångsidiga inlärningsmöjligheter med hjälp av digital teknologi",
      "följa upp och utvärdera hur användningen av gemenskapsbaserad, gruppbaserad digital teknologi påverkar vägledningsprocessen och vid behov göra ändringar i enlighet med de uppställda målen och gruppens behov",
      "använda den digitala teknologins möjligheter och verktyg i ett professionellt samarbete för att uppnå gemensamma mål",
    ],
  },
  "A5.4": {
    id: "A5.4",
    header: "Systematisk utveckling av användningen av teknologi i vägledninge",
    text: "Vägledaren utnyttjar nya teknologiska lösningar och främjar användningen av dem i vägledningsprocessen.",
    tunnistaa_ja_ymmartaa: [
      "den snabba utvecklingen av digital teknologi och dess inverkan på vägledningsarbetet",
      "hur digital teknologi kan stödja en förbättring av vägledningsprocessen och höja kundservicens kvalitet",
      "hur man kan följa upp och utvärdera hur effektiv användningen av digital teknologi är och vid behov göra ändringar",
      "hur integreringen av digital teknologi i vägledningsarbetet kan påverka de egna möjligheterna till yrkesmässig utveckling",
    ],
    osaa: [
      "följa utvecklingen av digital teknologi och hålla sig ajour med nya teknologiska lösningar som kan stödja vägledningsprocessen",
      "i sitt vägledningsarbete bedöma hur digital teknologi kan förbättra tillgången till och kvaliteten på tjänsterna",
      "utveckla sina egna färdigheter och aktivt förvärva nya teknologiska färdigheter, verktyg och tillämpningar",
      "lyssna på och beakta kundernas och kollegornas respons om användningen av digital teknologi samt utveckla vägledningsarbetet utifrån den",
      "hålla sig uppdaterad om branschens bästa praxis och dela information med kollegor om effektiv användning av digital teknologi i vägledningsarbetet",
    ],
  },
  "B1.1": {
    id: "B1.1",
    header: "Vägledningsprocessens delar",
    text: "Vägledaren betraktar vägledningen vid sidan av individens egen utveckling som en serviceprocess och samhällelig verksamhet. Flerkanalstjänster som används i vägledningen kan vara till exempel besökstjänster, distansservice i real- eller fördröjd tid, videokonferenser eller telefontjänster.",
    tunnistaa_ja_ymmartaa: [
      "individers och gruppers olika utgångspunkter och förmåga att planera och fatta beslut om sin egen framtid",
      "kundens och gruppens olika livserfarenheter, livsskeden och olika sociala och ekonomiska situationer som utgångspunkt för vägledningsprocesser",
      "faktorer, randvillkor och resurser som påverkar ordnandet och tillhandahållandet av vägledningstjänster",
      "de viktigaste intressentgrupperna bakom ordnandet av vägledningen",
      "vägledningens roll som en del av utbildnings-, näringslivs-, ungdoms-, social- och hälso- samt sjukvårdspolitiken",
      "förvaltningsområdenas gemensamma mål och riktlinjer för organiseringen av vägledning",
      "olika servicekanaler för genomförande av vägledning",
    ],
    osaa: [
      "se vägledning som en del av individens och gruppens livsprocesser",
      "se vägledning som en målinriktad interaktionssituation",
      "betrakta händelser relaterade till vägledningssituationen i de sammanhang de förekommer",
      "se vägledning som en individs subjektiva rättighet",
      "via flera kanaler utföra vägledningsarbete och tillhandahålla vägledningstjänster genom individuella och gemensamma processer som tillgodoser kundens behov",
    ],
  },
  "B1.2": {
    id: "B1.2",
    header: "Vägledning som process",
    text: "Vägledaren beaktar vägledningens informations-, interaktions- och processdimensioner. Informationsdimensionen handlar om individens kunskap om sig själv, omvärldens möjligheter och individens förhållande till sin egen verksamhetsmiljö. Interaktionsdimensionen är relaterad till att bygga upp och upprätthålla en relation. Processdimensionen omfattar en förståelse för sättet att hitta lösningar och sambanden mellan de faktorer som ligger bakom lösningarna.",
    tunnistaa_ja_ymmartaa: [
      "vägledningens processkaraktär i kundens självständiga arbete, i det vägledarstödda arbetet, i individuella samtal och gruppsamtal samt i samarbetsprocesser i olika sammanhang",
      "betydelsen av vägledningens innehåll, interaktion och processdimension",
      "att utgångspunkten för vägledningen är kundens och hela gruppens individuella situation, färdigheter och behov",
      "skillnaden mellan enskilda vägledningssituationer och långsiktiga vägledningsprocesser",
      "betydelsen av vägledningsprocessens övergripande struktur och de olika faserna i processens förlopp",
      "skillnader i maktrelationer mellan vägledare och kund samt variation i vägledarens roll i olika former av vägledning",
    ],
    osaa: [
      "tillsammans med kunden och grupperna bedöma deras situation och servicebehov",
      "bedöma kundens utgångsläge och välja ett ändamålsenligt tillvägagångssätt och arbetssätt utifrån kundens eller gruppens situation, sammanhang och behov av tjänster",
      "strukturera kundens situation och handlingsmöjligheter till en begriplig helhet under vägledningen",
      "planera, genomföra, utvärdera, leda, utveckla och förnya vägledningsprocesserna och vägledningen som resurs med beaktande av olika kundgruppers sammanhang, mångfald och bakgrund",
      "komma överens med kunden och grupperna om en process för att definiera målen och gränserna för vägledningen",
      "tillsammans med kunden och gruppen bedöma om vägledningen är ändamålsenlig med tanke på kundens eller gruppens situation, sammanhang och behov av tjänster",
      "arbeta med kunden och gruppen för att skapa gemensam mening, gemensamma arbetssätt och uppnå mål",
    ],
    context_competencies: [
      {
        context: "Grundläggande utbilding",
        tunnistaa_ja_ymmartaa: [
          "målen för handledningen i läroplansgrunderna för den grundläggande utbildningen och gymnasiet och i yrkesutbildningens examensgrunder samt vägledningens delområden och verksamhetsmodeller",
          "målen och verksamhetsmodellerna för handledningen som beskrivs i utbildningsanordnarens och skolans handledningsplan",
          "elevhandledningens gränssnitt till elevvården och den övriga verksamheten i skolan",
        ],
        osaa: [
          "bygga upp en vägledningshelhet som utnyttjar olika verksamhetsmodeller såsom klass-, grupp- och individuell handledning, arbetslivsförtrogenhet, besök samt mångprofessionellt och sektorsövergripande samarbete",
          "planera och genomföra situationer där eleverna lär sig färdigheter i självutvärdering",
          "bedöma elevernas behov av handledning och stöd med hjälp av olika handledningsmetoder och verktyg",
        ],
      },
      {
        context: "Gymnasieutbilding",
        tunnistaa_ja_ymmartaa: [
          "målen för handledningen i läroplansgrunderna för den grundläggande utbildningen och gymnasiet och i yrkesutbildningens examensgrunder samt vägledningens delområden och verksamhetsmodeller",
          "målen och verksamhetsmodellerna för handledningen som beskrivs i utbildningsanordnarens och gymnasiets handledningsplan",
          "studiehandledningens gränssnitt till elevvården och den övriga verksamheten i gymnasiet",
        ],
        osaa: [
          "bygga upp en målinriktad vägledningsprocess från ansökningsskedet fram till avläggandet av examen och vid behov som fortsatt handledning efter studiernas slut",
          "ordna väglednings- och handledningsstöd för studerande som behöver individuella lösningar vid övergången till gymnasiet",
          "samarbeta med grupphandledare för att uppnå målen för studiehandled- ningen i gymnasiet",
          "bygga upp en vägledningshelhet som utnyttjar olika verksamhetsmodeller såsom klass-, grupp- och individuell handledning, arbetslivsförtrogenhet, besök samt mångprofessionellt och sektorsövergripande samarbete",
          "planera och genomföra situationer där studerande lär sig färdigheter självutvärdering",
          "bedöma studerandes behov av handledning och stöd med hjälp av olika handledningsmetoder och -verktyg",
        ],
      },
      {
        context: "Yrkesutbilding",
        tunnistaa_ja_ymmartaa: [
          "målen för handledningen i läroplansgrunderna för den grundläggande utbildningen och gymnasiet och i yrkesutbildningens examensgrunder samt vägledningens delområden och verksamhetsmodeller",
          "målen och verksamhetsmodellerna för handledningen som beskrivs i utbildningsanordnarens styrdokument",
          "studiehandledningens gränssnitt till elevvården och läroanstaltens övriga verksamhet",
        ],
        osaa: [
          "bygga upp en målinriktad vägledningsprocess från ansökningsskedet fram till avläggandet av examen",
          "samarbeta med läroanstaltens lärare och andra aktörer för att uppnå målen för vägledningen och handledningen",
          "bygga upp en vägledningshelhet som utnyttjar olika verksamhetsmodeller såsom studerandes personliga utvecklingsplan för kunnandet, klass-, grupp- och individuell handledning, lärande i arbetslivet, besök samt mångprofessionellt och sektorsövergripande samarbete",
          "ordna väglednings- och handledningsstöd för studerande som behöver individuella lösningar vid övergången till yrkesutbildningen",
          "planera och genomföra situationer där studerande lär sig färdigheter i självutvärdering",
          "bedöma studerandes behov av handledning och stöd med hjälp av olika handledningsmetoder och -verktyg",
        ],
      },
      {
        context: "Högre utbildning",
        tunnistaa_ja_ymmartaa: [
          "målen för högskolans vägledning och innehåll samt arbetsfördelningen",
          "vägledningens gränssnitt till andra stödtjänster för studenter",
        ],
        osaa: [
          "bygga upp vägledningsprocessen till en målinriktad helhet från ansökningsskedet fram till avläggandet av examen",
          "samarbeta med lärartutorer och annan personal för att uppnå målen för vägledningen",
          "bygga en vägledningshelhet som utnyttjar olika verksamhetsmodeller såsom studentens individuella studieplan, grupp- och individuell vägledning, lärande i arbetslivet, karriärvägledning, besök samt multiprofessionellt och sektorsövergripande samarbete",
          "planera och genomföra situationer där studenterna lär sig färdigheter i självutvärdering",
          "bedöma studenternas behov av vägledning och stöd med hjälp av olika vägledningsmetoder och -verktyg",
        ],
      },
      {
        context: "Arbets- och näringstjänster (AN-tjänster, TE-palvelut)",
        tunnistaa_ja_ymmartaa: [
          "målgrupper och det totala utbudet av arbets- och näringstjänster",
          "sambandet mellan kundernas hälsofaktorer eller begränsningar och deras arbetsförmåga och anställningsbarhet",
          "stöd- och serviceformer som är tillgängliga för kunden",
        ],
        osaa: [
          "samarbeta med den övriga personalen för att uppnå målen för vägledningen",
          "samarbeta med kontrakterade stödtjänster",
          "utnyttja befintliga verktyg för att bedöma kundernas situation, servicebehov och lämplighet",
          "kartlägga kundernas kompetens och vid behov ordna bedömning av arbetsförmågan eller andra expertbedömningar för att utreda arbets-, företags- och utbildningsalternativ samt för att fastställa karriärplaner",
          "identifiera psykologiska och andra hinder för sysselsättning och kan arbeta med dem på ett målinriktat sätt",
          "bygga upp en vägledningshelhet som utnyttjar olika verksamhetsmodeller såsom kundens sysselsättningsplaner, arbetsträning, jobbsöknings- och karriärträning, karriärvägledning, arbets- och utbildningsprövning samt multiprofessionellt och sektorsövergripande samarbete",
          "vägleda kunderna att identifiera och formulera sina färdigheter för att främja deras anställbarhet",
          "använda psykologiska bedömningsmetoder och uppgifter med kundens samtycke som en del av vägledningsprocessen (gäller endast legitimerade psykologer)",
          "vägleda partiellt arbetsföra i sysselsättningen",
          "ge kunderna råd om vilka tjänster och stödformer som finns att tillgå",
        ],
      },
      {
        context: "Navigatorer",
        tunnistaa_ja_ymmartaa: [
          "Navigatorernas kundgrupper och totalutbud",
          "stöd- och serviceformer som är tillgängliga för kunderna",
        ],
        osaa: [
          "bygga upp en övergripande vägledningsprocess som utnyttjar sektorsövergripande samarbete",
          "samarbeta med utbildningsanordnares vägledare, lärare och andra aktörer för att uppnå målen för vägledningen",
          "ge kunderna råd om vilka tjänster och stödformer som finns att tillgå",
        ],
      },
    ],
  },
  "B1.3": {
    id: "B1.3",
    header: "Vägledningsprocessens resultat och effekter",
    text: "Vägledaren utvärderar systematiskt tillsammans med kunden resultaten och effekterna av vägledningsprocessen. Bedömningen fokuserar på processen och resultaten, uppnådda färdigheter och observerade förändringar i kundens situation. Utvärderingen av resultat och genomslag förutsätter kontinuerlig utvärdering av vägledningsprocessen med avseende på hur processen framskrider, hur vägledaren förbinder sig att erbjuda och utveckla tjänsten, hur vägledningen svarar mot användargruppernas behov, hur kunderna deltar i processen och planeringen av den, hur effektiva de vägledningsrelationer och verksamhetsmodeller som används är och hur utvärderingsinformationen utnyttjas i utvecklingen av tjänsterna.",
    tunnistaa_ja_ymmartaa: [
      "betydelsen av att utvärdera enskilda vägledningsprocessers resultat och effekt med tanke på utvecklingen av det egna arbetet",
      "betydelsen av att utvärdera vägledningsprocessens resultat och effekt sett ur individens synvinkel",
      "att vägledningsprocessens resultat påverkas av bland annat sammanhang, kundens livssituation, sociala nätverk och tillgängliga tjänster",
      "metoder och kriterier för utvärdering av vägledningsprocessens resultat och effekt",
      "hur man definierar utvärderingsmål och kriterier för att verifiera vägledningsprocessernas resultat och effekt",
      "resultaten av vägledningsprocessen, utvecklingen av kundens kompetens och förändringar i situationen",
    ],
    osaa: [
      "definiera målen för vägledningsprocessen tillsammans med kunderna/grupperna och följa upp hur de genomförs",
      "samla in respons från kunderna/grupperna under och i slutet av vägledningsprocessen",
      "handleda kunderna/grupperna att utvärdera sin egen utveckling och utvecklingen av sina egna färdigheter och kompetenser under processen",
      "förfina eller omdefiniera målen för vägledningen baserat på återkoppling och utvärderingsdata",
      "utveckla sitt agerande som vägledare utifrån respons",
      "analysera och utvärdera vägledningsprocesser och -metoder, egen yrkes- praxis samt deras kvalitet och effekt",
    ],
  },
  "B2.1": {
    id: "B2.1",
    header: "Utvecklings- och livsloppsorienterade teorier",
    text: "Vägledaren ser på vägledningen ur individens perspektiv, separat som en utvecklingsprocess, livssituation och dess sammanhang.",
    tunnistaa_ja_ymmartaa: [
      "kopplingen mellan teorier om individens utveckling och livslopp och den tidsperiod under vilken de utvecklades",
      "hur teoretisk kunskap relaterad till individens utveckling och livslopp tilllämpas i vägledningsprocessen",
      "hur kontexten, kundens livssituation, människorelationer och individuella faktorer påverkar vägledningsprocessen och måluppfyllelsen",
      "kunskapsbasen om faktorer som påverkar delaktighet och utslagning i det egna arbetet",
      "faktorer som påverkar välbefinnandet, funktionsförmågan och aktörskapet",
      "faktorer som påverkar emotionell, social, kulturell och kognitiv utveckling",
      "faktorer som påverkar lärandet och utvecklingen av den egna kompetensen",
    ],
    osaa: [
      "välja ett teoretiskt tillvägagångssätt som är lämpligt för situationen",
      "tillämpa centrala teorier relaterade till individuell utveckling, livslopp och kontext i vägledningsarbetet",
      "ta hänsyn till individuella utvecklingsstadier och individuella skillnader i psykisk, fysisk och social utveckling",
      "tillämpa forskning och teoretisk kunskap om delaktighet och utslagning i vägledningsarbetet",
      "utnyttja forskning och teoretisk kunskap om individuellt lärande, beteende, identitet, fysiskt, psykiskt och socialt välbefinnande samt aktörskap i vägledningsarbetet",
    ],
  },
  "B2.2": {
    id: "B2.2",
    header: "Teorier om karriärutveckling",
    text: "Vägledaren ser på karriärutveckling utgående från individens egenskaper, intressen och värderingar samt sammanhang. Karriärutveckling kan också beskrivas som en process som påverkas av historisk tid, ekonomi och de förhållanden som råder i samhället i övrigt, samt individens livsmiljö och relationer.",
    tunnistaa_ja_ymmartaa: [
      "karriärteoriernas koppling till tid och kontext",
      "centrala karriärteorier",
      "sambandet mellan karriärutveckling och människans utveckling och liv",
      "faktorer som påverkar karriärutvecklingen i individens sociala relationer, livssituation och nätverk",
      "delområden i färdigheterna om karriärplanering och betydelsen av att utveckla dem i kundens livs- och karriärplanering",
      "mångfalden och betydelsen av övergångar och övergångsskeden i en individs livslopp",
      "faktorer som påverkar anställbarhet och sysselsättning",
    ],
    osaa: [
      "kritiskt granska olika karriärteoriers tillvägagångssätt och tillämpbarhet i vägledningsprocessen",
      "tillämpa karriärteorier som är anpassade till individens eller gruppens behov",
      "ta hänsyn till kontextuella, relationella och individuella faktorer relaterade till karriärplanering under vägledningsprocessen",
      "vägleda kunden i att utveckla färdigheter i karriärplanering",
      "vägleda kunden genom övergångar",
      "vägleda kunden i utvecklingen av färdigheter relaterade till anställning",
    ],
  },
  "B2.3": {
    id: "B2.3",
    header: "Samhälle och arbetsliv",
    text: "Vägledaren ser på sitt arbete som en del av den samhälleliga och kulturella verkligheten som påverkar kundens situation och möjligheter att bygga upp sitt liv och sin karriär på ett jämlikt och hållbart sätt. Utöver individens egna mål och behov av vägledning påverkas ordnandet av vägledningen av samhälleliga-, hälso- och rehabiliteringspolitiska mål samt utbildnings- och arbetsmarknadspolitiska mål. Eftersom arbetslivet och individerna ständigt utvecklas kräver vägledningen en dynamisk förståelse av samhället och människors möjligheter att lära sig i takt med förändringarna.",
    tunnistaa_ja_ymmartaa: [
      "samhällets och arbetsmarknadens mest centrala verksamhetsprinciper",
      "hur samhällsstrukturer och -system påverkar det egna arbetet",
      "de globala ekonomiska faktorernas inverkan på arbetsmarknaden",
      "betydelsen av prognostiseringsdata och framtidskompetens i det egna arbetet",
      "olika signaler som förutspår förändringar",
      "hur förändringar i verksamhetsmiljön påverkar det egna arbetet",
      "gränssnittet mellan kundens intressen och arbetsmarknaden",
      "utbildningssystemets samhälleliga funktioner och vägledningens plats i dessa",
      "hur aktuella internationella och nationella trender påverkar kundens och organisationernas funktionsförmåga samt livs- och karriärplanering",
      "vägledningens betydelse för att uppnå likabehandling och jämlikhet i samhället",
      "vägledningens betydelse för att uppnå delaktighet och en hållbar livsstil i samhället",
    ],
    osaa: [
      "kritiskt granska samhälleliga utvecklingstendenser",
      "undersöka vilken roll ekonomiska och andra faktorer som påverkar människors liv spelar i kundens livs- och karriärplanering",
      "granska, av samhället konstruerade skillnader och maktrelationer mellan människor, inom utbildning och i arbetsliv",
      "ta hänsyn till hur förändringarna i arbetslivet påverkar enskilda personers karriärer, kompetensbehov och rörlighet",
      "utnyttja prognostiseringsdata och framtidskompetens i sitt eget arbete",
      "främja likabehandling och jämställdhet",
      "i vägledningen beakta faktorer som stärker en hållbar livsstil",
      "vägleda kunden när hen planerar sin utbildning och karriär i internationella sammanhang",
    ],
  },
  "B2.4": {
    id: "B2.4",
    header: "Vägledningsteorier",
    text: "Vägledaren tillämpar vägledningsteorier som tar hänsyn till individen och hens kontext på ett kundorienterat sätt. Vägledningsteoretisk kompetens ger vägledaren en grund för att bygga upp målinriktade, möjliggörande och lärande processer. Genom det teoretiska kunnandet struktureras vägledningen även som ett dialogiskt samspel mellan individer, vilket som arbetsmetod kan användas i olika interpersonella yrken.",
    tunnistaa_ja_ymmartaa: [
      "bakomliggande teorier för de metoder och verktyg som används i vägledningen och deras koppling till tid och kontext",
      "tillvägagångssätt för att strukturera och upprätthålla vägledningsrelationen",
      "tillvägagångssätt och metoder med vilka kunden kan stärka sin handlingsförmåga, sitt välbefinnande och sina färdigheter i karriärplanering",
      "teorier som strukturerar individuell vägledning",
      "teorier som strukturerar gruppbildning, grupptillhörighet och gruppaktiviteter",
      "vikten av att kartlägga kundens kompetens och vägledningsbehov med tanke på vägledningsprocessens effekt",
      "att kundens färdigheter i karriärplanering påverkas av individuella, relationella och kontextuella faktorer",
      "betydelsen av kulturella bakgrundsfaktorer som påverkar kundens karriärplanering och vägledningsprocess",
    ],
    osaa: [
      "beskriva och motivera hur hen planerar, implementerar och utvärderar vägledning och vägledningsprocesser genom att tillämpa vägledningsteorier",
      "bedöma den egna bruksteorins lämplighet i förhållande till kundens behov och situation",
      "bedöma den egna bruksteorins lämplighet för respektive vägledningsprocess",
      "vägleda kunden i att utveckla färdigheterna i karriärplanering genom att på ett mångsidigt sätt utnyttja olika vägledningsmetoder och -verktyg",
      "vägleda kunden i sysselsättning och i jobbsökningen genom att utnyttja olika metoder och verktyg på ett mångsidigt sätt",
    ],
  },
  "B2.5": {
    id: "B2.5",
    header: "Livslångt och kontinuerligt lärande",
    text: "Vägledaren säkerställer att kunder och grupper lär sig att bedöma och utveckla sina styrkor och kompetenser i förhållande till de möjligheter som verksamhetsmiljön erbjuder. I vägledningsprocessen betonas omfattande färdigheter som gör det möjligt för individen att observera förändringar i sin egen verksamhetsmiljö, fastställa sina egna inlärningsmål, utveckla sin resiliens och aktivt skapa förändring och utveckling i sitt eget liv och sin karriär.",
    tunnistaa_ja_ymmartaa: [
      "betydelsen av livslång kompetensutveckling och kontinuerligt lärande i individens livslopp",
      "karriärplanering som ett livslångt kontinuum och som en livslång inlärningsprocess",
      "färdigheter i karriärplanering som ett självständigt, mångsidigt kunnande man kan lära sig",
      "betydelsen av färdigheter i karriärplanering i olika livssituationer och övergångar",
      "central teoretisk kunskap och forskning relaterad till lärande",
      "faktorer och verksamhetsmodeller i anslutning till erkännande av kunnande",
      "faktorer som inverkar på kundens inlärningsförmåga, resiliens och välbefinnande, neuropsykiatriska utmaningar och deras inverkan på lärandet, kompetensutveckling, karriärplanering och genomförandet av planerna",
      "hur kundens tidigare studieerfarenheter påverkar karriärplanering och genomförandet av planerna",
      "betydelsen av allmänna arbetslivsfärdigheter i karriärplanering och sysselsättning",
    ],
    osaa: [
      "i vägledningssituationer tillämpa funktionella arbetssätt utgående från kundens problem",
      "utgående från kundens problem skapa funktionella inlärningssituationer som gör det möjligt för kunden att utveckla sina färdigheter i karriärplanering",
      "handleda kunden i att utveckla sin förmåga till självvärdering så att hen kan beskriva sina styrkor, sin kompetens och sina utvecklingsområden",
      "handleda kunden i att utveckla studie- och självregleringsfärdigheter",
      "vägleda kunden i att utveckla användningen av digital teknologi och färdigheter i informationssökning",
      "identifiera vanliga problem i anslutning till inlärnings- och studiefärdigheter och vid behov hänvisa kunden till stödtjänster för lärandet",
      "vägleda kunden att agera för att uppnå sina planer och mål",
      "vägleda kunden i att utveckla sin förmåga till självreflektion och färdigheter i självutvärdering så att hen kan analysera sin egen inlärningsprocess och utvecklingen av sina egna färdigheter",
    ],
  },
  "B2.6": {
    id: "B2.6",
    header: "Vägledningsfilosofi",
    text: "Vägledaren granskar sin egen och kundens världsbild genom att medvetandegöra begrepp och strukturer. Målet är att stärka individens självkännedom och strukturera livets grunder och övertygelser. Filosofiska frågor om vägledning är kopplade till de etiska principerna för vägledning.",
    tunnistaa_ja_ymmartaa: [
      "sambanden mellan vägledningsfilosofiska perspektiv och den egna vägledningsorienteringen",
      "olika världsåskådningars dimensioner och innehåll",
      "sambandet mellan filosofiska vägledningsfrågor och etiska principer",
    ],
    osaa: [
      "definiera sin egen världsbild och människosyn och deras inverkan på den egna vägledningsorienteringen",
      "respektera kundens världsbild och värderingar",
      "vägleda kunden i att definiera sin värdegrund och därigenom utveckla sin självkännedom",
      "kritiskt granska världen och framtiden samt de värderingar som råder i samhället",
      "vägleda kunden i att utveckla sin förmåga till kritisk utvärdering",
    ],
  },
  "B3.1": {
    id: "B3.1",
    header: "Informationssökning och -hantering",
    text: "Vägledaren ser till att hen själv, kunder och grupper har tillgång till aktuella informationskällor som stöd för planer och beslut gällande livet, studierna och arbetet. Vägledaren ser till att kunden och gruppen utvecklar de färdigheter som krävs för att inhämta, utvärdera och utnyttja information när de gör planer och val som rör deras eget liv.",
    tunnistaa_ja_ymmartaa: [
      "aktuella och tillförlitliga informationskällor som hen kan utnyttja i sitt eget arbete",
      "kvalitetskriterier med vilka hen bedömer tillförlitligheten i den information och de informationskällor som hen använder",
      "vikten av aktuell arbetsmarknadsinformation i vägledningen",
      "informationskällor som ger aktuell information om utbildnings- och sysselsättningsalternativ",
      "informationskällor om företagande",
      "informationskällor om tillgängliga stödformer",
      "relevanta informationskällor om andra tillgängliga tjänster",
    ],
    osaa: [
      "välja aktuellt, pålitligt och lämpligt material",
      "söka information om utbildningsmöjligheter och tillhörande urvalsförfaranden",
      "söka information om sysselsättningsalternativ och olika arbetsformer samt metoder för att söka arbete",
      "söka information om företagande",
      "söka information om befintliga stödformer som finns tillgängliga",
      "vägleda kunden i informationssökning, utvärdering och användning av information",
    ],
  },
  "B3.2": {
    id: "B3.2",
    header: "Reflektera och sätta upp mål",
    text: "Vägledaren skapar en konfidentiell vägledningsrelation. Vägledaren kartlägger kundens eller gruppens vägledningsbehov och ställer upp målen för vägledningsprocessen tillsammans med kunden eller gruppmedlemmarna.",
    tunnistaa_ja_ymmartaa: [
      "vikten av att bygga upp en vägledningsrelation i ett tidigt skede av vägledningsprocessen och att kartlägga behovet av vägledning",
      "att färdigheterna i karriärplanering har en flerdimensionell karaktär",
      "att vägledningssituationen påverkas både av kundens individuella målsättningar och av den egna organisationens instruktioner och målsättningar beträffande organiserandet av vägledningen",
      "organisationens anvisningar och dokument för uppgörande av kundens individuella utvecklingsplan",
      "vikten av mångprofessionellt och sektorsövergripande samarbete under vägledningsprocessen",
    ],
    osaa: [
      "särskilja kundens individuella mål samt de administrativa målen och målen för vägledning som är relaterade till organisationens grunduppgift och gäller alla kundgrupper",
      "bedöma kundens eller gruppens kompetensnivå och utvecklingsområden gällande färdigheterna i karriärplanering",
      "utnyttja olika verktyg och metoder för att kartlägga kundens och gruppers färdigheter och vägledningsbehov",
      "bygga upp en konfidentiell vägledningsrelation",
      "vägleda kunden eller gruppen i att utveckla självkännedom och färdigheter i självutvärdering",
      "vägleda kunden i att identifiera och beskriva sin kompetens",
      "sätta upp mål för vägledningsprocessen tillsammans med kunden eller gruppen",
      "förhandla med kunden och grupper om de former, metoder och servicekanaler som ska användas under vägledningsprocessen",
      "vid behov genomföra multiprofessionellt och sektorsövergripande samarbete",
      "identifiera och formulera gränserna för sitt yrke och sin kompetens",
    ],
  },
  "B3.3": {
    id: "B3.3",
    header: "Kundcentrerad vägledningsprocess",
    text: "Vägledaren planerar och genomför tillsammans med kunderna en vägledningsprocess som motsvarar deras beredskap och behov. Vägledaren följer upp och bedömer hur vägledningsprocessen framskrider i enlighet med de verksamhetsmodeller och mål som överenskommits tillsammans med kunden eller gruppen. Vägledaren följer upp och utvärderar hur de uppställda målen uppnås tillsammans med kunden.",
    tunnistaa_ja_ymmartaa: [
      "kundens och gruppens individuella färdigheter och utgångspunkter för att planera sin framtid och karriär",
      "karriärplanerings- och beslutsprocessens form, dess skeden och relaterade faktorer",
      "kundorientering i vägledningen",
      "vikten av att följa upp och utvärdera målen för vägledningsprocessen och hur genomförandet av målen framskrider",
      "vikten av att använda mångsidiga och ändamålsenliga interventioner, aktiviteter och metoder",
      "vikten av att samla in feedback i slutet av vägledningsprocessen",
    ],
    osaa: [
      "vägleda kunden eller gruppen med hjälp av lämpliga metoder, verktyg och servicekanaler",
      "dokumentera hur vägledningsprocessen fortskrider",
      "tillämpa karriär- och vägledningsteorier på ett ändamålsenligt sätt under vägledningsprocessen",
      "bedöma hur vägledningsprocessen framskrider för att uppnå målen",
      "bedöma om de fastställda målen bör ses över under vägledningsprocessen",
      "välja arbetsformer där kunden är en aktiv aktör",
      "välja interventioner och verktyg som hjälper kunderna och grupperna att stärka sin handlingskraft och kompetens för självständigt arbete",
      "vid behov samarbeta med utbildningsanordnare, arbetslivet och andra aktörer och intressentgrupper",
      "se till att material och informationskällor som används är aktuella och tillförlitliga",
      "vägleda kunderna och grupperna att vidga sina perspektiv och uppfattningar om befintliga alternativ",
      "vägleda kunderna och grupperna att bedöma hur lämpliga olika alternativ är för dem själva",
      "vägleda kunderna och grupperna att utveckla sin förmåga att fatta beslut",
      "vägleda kunderna och grupperna att genomföra sina planer och nödvändiga konkreta åtgärder",
      "vägleda kunderna och grupperna att utveckla färdigheter som behövs i övergångar och övergångsskeden",
      "besluta om vägledningsprocessen och samla in respons om kundens eller gruppens erfarenheter under processen",
      "utveckla sina egna arbetsmetoder utifrån respons och utvärderingsdata",
    ],
  },
  "B3.4": {
    id: "B3.4",
    header: "Utvärdering",
    text: "Vägledaren utvärderar tillsammans med kunden resultaten och effekterna av vägledningsprocessen. Bedömningen omfattar inlärningsresultat och färdigheter i karriärplanering som utvecklats genom vägledningen, förändringar i funktionsförmågan, välbefinnandet, aktörskapet och kompetensen samt den egna livssituationen och karriärutvecklingen. Dessutom utreds vad kunden har lärt sig av vägledningsprocessen och hur hen kommer att utnyttja denna kompetens i framtiden.",
    tunnistaa_ja_ymmartaa: [
      "kvalitativa och kvantitativa resultat av vägledningen och dess effekt för individen",
      "principer för dokumentation av vägledningsprocessen",
      "betydelsen av vägledningsprocessen och dess mål samt utvärdering av hur de har uppnåtts",
      "utvärderingen av resultaten av enskilda vägledningsprocesser som en del av organisationens utvärdering av effekten och kvaliteten i dess verksamhet",
    ],
    osaa: [
      "identifiera vägledningsprocessens kvalitativa och kvantitativa resultat och effekt samt utvärderingsobjekt, informationskällor och kriterier, för att påvisa dessa",
      "dokumentera hur vägledningsprocessen framskrider och utnyttja dokumentationen som bakgrundsmaterial för utvärdering av vägledningsprocessen",
      "använda nödvändiga kvalitativa och kvantitativa former och metoder för att bedöma resultatet och effekten av en enskild vägledningsprocess",
      "identifiera hur kunderna och grupperna har uppnått sina mål",
      "vägleda kunderna och grupperna att utvärdera förändringarna och resultaten som de har upplevt under vägledningsprocessen och färdigheterna i karriärplanering som de har utvecklat",
      "utveckla sina egna arbetsmetoder på basis av utvärderingsinformationen",
    ],
  },
  "C1.1": {
    id: "C1.1",
    header: "Vägledning i samhället",
    text: "Vägledaren beaktar fenomen, relationer, trender och förändringar inom utbildning, arbetsliv och samhälle och utnyttjar prognostisering i sitt arbete. Dessutom har hen färdigheter att främja en sådan vägledning som är medveten om strukturer och ett hållbart, jämlikt, rättvist och mångsidigt samhälle.",
    tunnistaa_ja_ymmartaa: [
      "samband mellan utbildning, arbetsliv och samhälle samt fenomen, trender, förändringar och prognostisering inom dessa",
      "vägledning som en del av samhällets servicestrukturer",
      "vägledningens systemiska betydelse för individer, sammanslutningar, tjänsteproducenter och samhällsutvecklingen",
      "vägledningens betydelse för utbildningspolitik, arbetsmarknad, social inkludering, ekonomisk utveckling och en hållbar framtid",
      "vikten av att främja jämlikhet, social rättvisa och samhällelig mångfald i vägledningen",
      "positioneringen av den egna rollen som en del av de nationella målen för livslångt och kontinuerligt lärande och kompetensutveckling",
    ],
    osaa: [
      "inhämta och utvärdera aktuell information om utbildning, arbetsliv och samhällsfrågor",
      "beakta förändringar i arbetslivet och samhället samt prognostisering om framtiden i sitt arbete",
      "främja en vägledning som är medveten om samhälleliga strukturer och ett jämlikt, rättvist och mångsidigt samhälle",
      "följa med forskning och offentlig debatt om ordnandet av vägledning",
      "lokalisera vägledningstjänsternas ställning och roll som en del av det nationella vägledningsekosystemet",
      "främja planering och genomförande av forskning som gäller det egna ar- betet och dess verksamhetsförutsättningar",
      "delta i beredningen av riktlinjer som gäller det egna arbetet och dess verksamhetsförutsättningar",
    ],
  },
  "C1.2": {
    id: "C1.2",
    header: "Vägledning av livslång karaktär",
    text: "Vägledaren säkerställer att kärnan i livslångt och kontinuerligt lärande är fungerande, kundorienterad och etiskt högklassig samt att livslång vägledning för individen och grupper i olika skeden av studier och karriär är professionellt och systemiskt producerade.",
    tunnistaa_ja_ymmartaa: [
      "vägledningen som ett kontinuum i alla skeden av en individs liv",
      "vägledningens systemiska betydelse för individer, sammanslutningar, tjänsteproducenter och samhällsutvecklingen",
      "vägledningens ställning och betydelse som en del av individers, gruppers och sammanslutningars livslånga och kontinuerliga lärande och kompetensutveckling",
      "vägledningens roll som ett tema som genomsyrar och förenar olika förvaltningsområden",
      "olika förvaltningsområdens särdrag och utgångspunkter för ordnandet av vägledningen",
      "nationella och internationella principer för ordnande av förvaltningsövergripande och sektorsövergripande vägledning",
      "principerna och formerna för olika förvaltningsområdens vägledningsformer, som skapar en grund för ömsesidigt samarbete och kollegialt lärande",
      "den egna rollens positionering som en del av lokala och nationella arrangemang för livslång vägledning",
    ],
    osaa: [
      "beakta kundens och kundgruppens livssituation som en del av det livslånga och kontinuerliga lärandet",
      "arbeta med olika kundgrupper i olika livssituationer",
      "säkerställa en oavbruten servicekedja i övergångsskeden",
    ],
  },
  "C1.3": {
    id: "C1.3",
    header: "Vägledningens ställning och positionering",
    text: "Vägledaren följer aktuell forskning och deltar i samhällsdebatten inom området. För att visa hur viktig och värdefull livslång vägledning är för att uppnå målen för central utbildnings-, sysselsättnings-, ekonomi- samt välfärds- och rehabiliteringspolitik krävs en dialog mellan vägledare och beslutsfattare.",
    tunnistaa_ja_ymmartaa: [
      "vägledningens systemiska betydelse för individer, grupper, sammanslutningar, serviceproducenter och samhällsutvecklingen lokalt, nationellt och internationellt",
      "vägledningens betydelse för att främja likabehandling och jämställdhet samt en hållbar livsstil",
      "beslutsprocesser för ordnandet av vägledningen",
      "centrala beslutsfattare som ansvarar för ordnandet av vägledning och deras ansvarsområden",
      "betydelsen av utvärdering och forskning gällande vägledningens resultat och effekt som grund för beslutsfattande",
    ],
    osaa: [
      "identifiera vägledningsprocessens delområden för att beskriva vägled- ningens ställning och grundläggande uppgift för kunder, samarbetspartner, olika intressenter och beslutsfattare",
      "aktivt följa samhällsutvecklingen och den aktuella debatten samt mångve- tenskaplig forskning ur vägledningens synvinkel",
      "beakta främjandet av likabehandling, jämlikhet och en hållbar livsstil i vägledningen",
      "beakta de mål som individen ställer upp för sitt liv och sin verksamhet samt målen för utbildningssystemets och arbetslivets funktion",
      "visa för beslutsfattare och finansiärer av tjänster att vägledning ger mervärde och att de resurser som investeras i tillhandahållandet av tjänster är effektiva och ändamålsenliga",
      "identifiera evidensbaserade nyckelområden för utvecklingen av vägledningen",
      "identifiera nödvändiga åtgärder och lösningsalternativ som grund för beslutsfattande om vägledningen",
      "delta i den offentliga debatten som anknyter till vägledning",
      "inkludera forsknings- och utvärderingsresultat om tjänster som underlag för beslut om hur vägledningen ska organiseras",
      "delta i utvecklingen av en regional verksamhetsmodell för att fastställa vägledningens roll",
      "samarbeta med lokala, nationella och internationella partner för att främja vägledningens mål och verksamhetsförutsättningar",
    ],
  },
  "C2.1": {
    id: "C2.1",
    header: "Organisationer och nätverk",
    text: "Vägledaren tillämpar organisations- och nätverksteorier vid fastställande av gemensamt överenskomna mål för vägledning samt vid planering, genomförande och utvärdering av tjänster. Vägledaren arbetar i sektorsövergripande nätverk och främjar tjänsternas kontinuitet och enhetlighet i olika skeden av livet.",
    tunnistaa_ja_ymmartaa: [
      "sammanslutningar och samfund som tillhandahåller vägledningstjänster",
      "vilka faktorer som främjar eller begränsar organisationens, nätverkens och olika aktörers verksamhet för att uppnå ett gemensamt mål",
      "hur organisationens och nätverkets uppgifter är fördelade mellan olika aktörer",
      "hur organisations- och nätverksstrukturer (makt, ledarskap, ansvarsfördelning) påverkar organiseringen av vägledningen",
      "hur organisationens och nätverkens verksamhetskulturer (verksamhetssätt, värderingar, regler, språk och relationer mellan aktörerna) påverkar ordnandet av vägledningen",
      "hur organisationerna skapar förutsättningar för tillhandahållande av vägledningstjänster och den sociala växelverkan som verksamheten förutsätter",
      "hur organisationen och nätverket är en del av vägledningsekosystemet (mål, styrdokument, resurser, verksamhet och syfte med tillvaron)",
    ],
    osaa: [
      "uppfatta både den egna och organisationens roll och ställning i nätverksarbetet",
      "förstå hur organisations- och nätverksstrukturer och verksamhetssätt inverkar på ordnandet av vägledning",
      "tillämpa organisations- och nätverksteorier för att definiera gemensamma mål, planering, genomförande och utvärdering av vägledningen",
    ],
  },
  "C2.2": {
    id: "C2.2",
    header: "Strategiskt lärande",
    text: "Vägledaren ser livslång vägledning som en del av individens livsplanering, ett bredare samhälleligt sammanhang och olika organisationers servicestruktur. Ordnandet och utvecklandet av vägledningen är specifikt kopplade till väg- ledningens samhälleliga funktion, serviceproducenternas verksamhet, vägled- ningspersonalens kompetens samt vägledningsprocesserna mellan kunder, grupper och vägledare. Vägledarens och hens samarbetsnätverks lärande grundar sig på nätverksmedlemmarnas gemensamma lärande. I nätverken kan den gemensamt planerade verksamheten medföra positiva förändringar både i vägledarens egen och i samarbetsnätverkens verksamhet.",
    tunnistaa_ja_ymmartaa: [
      "principerna för och betydelsen av systemtänkande för planering och genomförande av vägledningstjänster",
      "det strategiska lärandets roll och betydelse för den kontinuerliga utvecklingen av det egna vägledningsarbetet och verksamheten i de egna samarbetsnätverken",
      "viktiga strategiska utvecklingsmetoder",
    ],
    osaa: [
      "identifiera förändringsfaktorer i verksamhetsmiljön som påverkar det egna vägledningsarbetet tillsammans med aktörer och intressentgrupper som deltar i ordnandet av vägledningen",
      "granska vägledningen i det sammanhang där den genomförs",
      "ta hänsyn till kopplingarna mellan de olika delarna av vägledningen",
      "kartlägga nuläget i den egna vägledningen och de viktigaste förändringsbehoven",
      "utvärdera vägledningsprocessen och utnyttja utvärderingsresultaten i planeringen och beslutsfattandet gällande vägledningen",
    ],
  },
  "C3.1": {
    id: "C3.1",
    header: "Multiprofessionellt nätverkande",
    text: "Vägledaren samarbetar multiprofessionellt med andra yrkesgrupper i olika skeden av vägledningsprocessen individuellt och i grupp. De vägledningsområden som kräver arbetsfördelning är stöd för funktionsförmåga och välbefinnande, kompetensutveckling samt karriär- och livsplanering.",
    tunnistaa_ja_ymmartaa: [
      "att flera parallella perspektiv och bakgrundsfaktorer är samtidigt involve- rade i vägledningssituationer",
      "olika begrepp som används av olika organisationer för att beskriva vägledningsarbetet",
      "som ett kontinuum och nätverksbaserat till sin natur",
      "den egna organisationens och regionala aktörers handlingsplan samt gemensamt överenskomna övergripande mål för vägledningen",
      "ansvarsområden, resurser, kompetensområden och uppgifter för olika professionella yrkesutövare inom vägledning i lokala nätverk",
      "den egna rollen och ställningen i nätverksarbetet med individer eller grupper i olika skeden av vägledningsprocessen",
      "gränserna för det egna yrket och kompetensen i vägledningsarbetet",
    ],
    osaa: [
      "undersöka kundsituationer ur många olika perspektiv",
      "träffa vägledare inom olika förvaltningsområden som jämlikar",
      "respektera olika synvinklar i vägledningen och tolerera oklarheter i situationen",
      "öppna upp begrepp och utgångspunkter för det egna arbetet",
      "skapa en gemensam förståelse utifrån olika synvinklar som grund för olika aktörers mångprofessionella arbete",
      "etablera lämpliga samarbetsrelationer",
      "arbeta i olika multiprofessionella arbetsgrupper och samarbetsnätverk och vid behov komma överens om kundens eventuella överföring till andra aktörer i samarbetsnätverket",
      "i sektorsövergripande samarbete säkerställa att ansvaret för klientens vägledningsprocess är tydligt definierat mellan aktörerna",
      "identifiera betydelsen av multiprofessionellt samarbete för utvecklingen av den egna organisationens vägledningsverksamhet",
    ],
  },
  "C3.2": {
    id: "C3.2",
    header: "Sektorsövergripande nätverk",
    text: "Vägledaren samarbetar med olika organisationer som erbjuder vägledningstjänster för att utveckla regionala sektorsövergripande vägledningstjänster och dela med sig av god praxis. I det sektorsövergripande samarbetet utreds relationsnätverken mellan organisationer och intressentgrupper som tillhandahåller vägledningstjänster, skillnaderna mellan organisationernas uppgifter och relationer samt gränssnittet mellan servicearrangemang och gemensamma tjänster. I sektorsövergripande nätverkande samarbetar vägledaren med aktörer och intressentgrupper inom olika förvaltningsområden i olika skeden av vägledningsprocesserna för individer och grupper.",
    tunnistaa_ja_ymmartaa: [
      "betydelsen av det övergripande regionala målet för den gemensamt överenskomna vägledningen",
      "vikten av gemensamma överenskommelser och kunskapsbildning",
      "regionala användargrupper av tjänster samt regional efterfrågan och behov av vägledning",
      "partner och intressenter samt deras eventuella förväntningar på resultatet av vägledningen",
      "centrala intressentgrupper och serviceproducenter som ansvarar för ordnandet av vägledningen samt deras kompetensområden",
      "de lokala tjänsteleverantörernas särdrag med tanke på behov för vägledning till lämplig service",
      "den egna organisationens grundläggande uppgift och dess gränser i ett regionalt sektorsövergripande nätverk av vägledningstjänster",
    ],
    osaa: [
      "delta i bildandet av det samarbetsnätverk som krävs för att organisera regionala vägledningstjänster",
      "delta i organiseringen av arbetet i det regionala samarbetsnätverket eller de regionala samarbetsgrupperna för att uppnå gemensamt överenskomna mål",
      "planera och genomföra sitt arbete i ett sektorsövergripande nätverk med beaktande av både den egna organisationens och det regionala sektorsövergripande nätverkets mål för ordnandet av vägledningen",
      "utarbeta en handlingsplan för den egna organisationens vägledningsar- bete som en del av det regionala samarbetsnätverket",
      "komma överens om varje aktörs ansvarsområden",
      "säkerställa tillräckliga befogenheter för att verka i nätverket",
      "komma överens om grunderna för gemensam kommunikation, information och informationsutbyte",
      "vid behov komma överens med kunden om att hen överförs till andra aktörer inom nätverket",
      "i sektorsövergripande samarbete se till att ansvaret för kundens vägled- ningsprocess är tydligt definierat mellan aktörerna",
      "utveckla sina egna nätverks- och samarbetsfärdigheter",
      "främja nätverkssamarbete",
    ],
  },
  "C4.1": {
    id: "C4.1",
    header: "Planering och organisering",
    text: "Vägledaren planerar och organiserar vägledningsarbetet i enlighet med lokala behov och verksamhetsförutsättningar samt med beaktande av administrativa anvisningar och bestämmelser.",
    tunnistaa_ja_ymmartaa: [
      "vikten av strategisk kompetens i vägledningsarbetet",
      "föreskrifter och administrativa anvisningar som styr ordnandet av vägledningen",
      "tjänsternas användargrupper",
      "vägledningen som en del av organisationens övergripande verksamhet och verksamhetskultur",
      "det egna vägledningsarbetet som en del av det regionala och lokala vägledningsekosystemet",
      "tillgängliga resurser och de totala sektorsövergripande resurserna för tillhandahållandet av tjänsterna",
      "grunden för den lämpligaste och effektivaste användningen av befintliga totala sektorsövergripande resurser",
    ],
    osaa: [
      "utarbeta en handlingsplan som grund för sitt eget arbete",
      "identifiera vägledningstjänsternas viktigaste användargrupper inom sitt förvaltningsområde",
      "göra en analys av servicebehov för olika användargrupper",
      "planera vägledningen och vägledningstjänsterna som en del av den egna organisationens verksamhet",
      "planera vägledningstjänsterna som en del av de regionala samarbetsnätverkens tjänster",
      "skapa en kultur av förtroende och öppenhet i den egna arbetsgemenskapen som grund för samarbete",
      "proaktivt utveckla vägledningen och vägledningstjänsterna",
    ],
    context_competencies: [
      {
        context: "Grundläggande utbildning och utbildning på andra stadiet",
        tunnistaa_ja_ymmartaa: [
          "lagstiftningen stadievis, läroplans- och examensgrunderna",
          "övriga stadievisa administrativa anvisningar",
          "planer utarbetade av utbildningsanordnaren och specifika för läroanstalten",
        ],
        osaa: [
          "planera, genomföra och utvärdera handledningen i enlighet med den stadievisa lagstiftningen och administrativa anvisningar, läroplaner och examensgrunder som styr verksamheten",
          "planera, genomföra och utvärdera i enlighet med utbildningsanordnarens och läroanstaltens egna planer",
        ],
      },
      {
        context: "Högre utbildning",
        tunnistaa_ja_ymmartaa: [
          "högskolelagstiftning, administrativa anvisningar och examenskriterier",
          "högskolespecifika planer som styr verksamheten",
        ],
        osaa: [
          "planera, genomföra och utvärdera vägledningen i enlighet med högskolelagstiftningen och administrativa riktlinjer",
          "planera, genomföra och utvärdera vägledningen enligt den egna högskolans planer",
        ],
      },
      {
        context: "Arbets- och näringstänster (AN-tjänster, TE-palvelut)",
        tunnistaa_ja_ymmartaa: [
          "lagstiftning samt nationella och regionala anvisningar för arbets- och näringstjänsterna",
          "gemensamma verksamhetsprinciper, planer och anvisningar för den egna organisationen",
        ],
        osaa: [
          "planera, genomföra och utvärdera vägledningstjänster i enlighet med lagstiftningen samt de administrativa och organisatoriska anvisningarna",
          "respektera individens rätt till självbestämmande och autonomi i överensstämmelse med andra skyldigheter",
        ],
      },
      {
        context: "Navigatorer",
        tunnistaa_ja_ymmartaa: [
          "lagstiftning om Navigatorerna samt nationella och regionala riktlinjer",
          "den egna organisationens gemensamma verksamhetsprinciper, planer och anvisningar",
        ],
        osaa: [
          "utforma, genomföra och utvärdera vägledningstjänster i enlighet med nationella, regionala och organisatoriska riktlinjer",
        ],
      },
    ],
  },
  "C4.2": {
    id: "C4.2",
    header: "Kvalitetsbedömning och uppföljning",
text:"Vägledaren främjar en systematisk bedömning av vägledningens kvalitet och genomslagskraft. Bedömningen av vägledningens genomslagskraft och kvalitet omfattar tjänsternas resultat, genomförandet av tjänsterna och tjänsteprocessen, tjänstestrukturerna, de totala resurserna som reserverats för genomförandet av vägledningen samt tillvägagångssätten för kvalitetsbedömningen som helhet och organisationens kvalitetskultur.",
    tunnistaa_ja_ymmartaa: [
      "vägledningens resultat, effekt och kvalitet ur samhällets, tjänsteleverantörernas och kundernas synvinkel",
      "de viktigaste kvantitativa och kvalitativa metoderna och verktygen för kvalitetsbedömning",
      "olika användargrupper och deras behov av tjänster",
      "hur väl vägledningen svarar mot efterfrågan och individers, gruppers och olika intressentgruppers behov",
      "hur väl individer och grupper gör framsteg mot de uppsatta målen",
      "hur tillgängliga vägledningstjänsterna är",
      "hur välfungerande kundrelationerna är i vägledningen",
      "hur kunderna uppfattar tjänsten",
      "hur tjänsterna förvaltas",
      "de viktigaste kriterierna för högklassig vägledning",
      "hur man agerar i nätverk för att utveckla vägledningen och dess kvalitet",
      "hur man dokumenterar vägledningsprocesser och deras resultat som grund för kunskapsbaserad ledning",
      "hur kompetens och verksamhet påverkar vägledningens kvalitet totalt sett",
    ],
    osaa: [
      "identifiera de viktigaste resultaten av sitt arbete ur individens, den egna organisationens och samhällets perspektiv",
      "identifiera nödvändiga kvantitativa och kvalitativa kriterier samt den information som krävs för att påvisa resultaten av vägledningen",
      "utarbeta arbetsformer där det möjliga resultatet av vägledningen kan dokumenteras",
      "dokumentera produktiviteten och effekterna av sitt eget arbete",
      "systematiskt samla in kvantitativ och kvalitativ information om genomförandet av vägledningen",
      "tolka information om ordnandet av vägledningen med tanke på tjänsternas kvalitet och effekt",
      "kombinera information om ordnandet av vägledningen med annan tillgänglig forsknings- och utvärderingsinformation",
      "utveckla sitt eget arbete utgående från erhållna utvärderingsresultat",
      "sprida utvärderingsinformation som grund för systematisk utveckling av arbetet till kollegor, forskare och beslutsfattare",
      "följa med forskning inom området, som kan tillämpas för att utveckla det egna arbetet",
    ],
  },
  "C4.3": {
    id: "C4.3",
    header: "Kontinuerlig utveckling",
    text:"Vägledaren undersöker de principer, värderingar, uppfattningar, strukturer, riktlinjer och praktiska verksamhetsförutsättningar som ligger till grund för vägledningen. Kontinuerlig utveckling av vägledningstjänster som baserar sig på strategiskt lärande omfattar utvärdering och analys av tjänster, visioner, kommunikation och verksamhet samt kontinuerligt lärande.",
    tunnistaa_ja_ymmartaa: [
      "globala och samhälleliga trenders och förändringars inverkan på ekonomin och arbetslivet",
      "hur förändringarna i samhället bestämmer utgångspunkterna för ordnandet av vägledningen",
      "olika kundgruppers behov och intressenters förväntningar som påverkar utgångspunkterna för ordnandet av vägledningen",
      "centrala teorier, värderingar, nationella riktlinjer och styrdokument gällande ordnandet av vägledningen",
      "centrala intressentgrupper som deltar i ordnandet av vägledningen",
      "beslutsprocesser för ordnandet av vägledningen",
      "de totala tillgängliga resurserna för ordnandet av vägledningen",
      "de viktigaste faktorerna i sektorsövergripande vägledningsarrangemang",
    ],
    osaa: [
      "i sitt utvecklingsarbete beakta de centrala faktorerna och mekanismerna i vägledningsprocessen",
      "inhämta och utvärdera aktuell information om utbildning, arbetsliv och samhällsfrågor",
      "göra en lägesbedömning av situationen i den egna verksamhetsmiljön",
      "kritiskt utvärdera och utnyttja prognostiseringsinformation om framtiden",
      "identifiera de viktigaste trenderna och externa förändringsfaktorerna i anslutning till ordnandet av vägledningen",
      "förstå sin egen och omgivningens roll i byggandet av framtiden",
      "identifiera sina egna och samarbetsnätverkets styrkor och utvecklingsområde",
      "utnyttja respons och utvärderingsdata vid planering och utveckling av den egna och samarbetsnätverkets verksamhet",
      "utarbeta en verksamhets- och utvecklingsplan för det egna arbetet och mätbara uppföljningsmål",
      "delta i den kontinuerliga utvecklingen av samarbetsnätverket och i utarbetandet av en gemensam handlingsplan",
      "delta i organiseringen av samarbetsnätverkets arbete i syfte att uppnå gemensamma mål",
      "agera proaktivt för att säkerställa gemensamma totalresurser och befogenheter",
      "systematiskt dokumentera och rapportera nätverksarbetets resultat i en- lighet med gemensamt överenskomna principer",
      "etablera nya arbetsformer och systematisk utvärdering av dem som grund för kontinuerligt lärande och utveckling",
    ],
  },
};